// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xamhihpqeuhtsquvbrdz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhhbWhpaHBxZXVodHNxdXZicmR6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NjM1MzUsImV4cCI6MjA2OTUzOTUzNX0.LaEwILLUhcg3F-nIgH5NIyLZPJg7YQi8QNfOtTO9B94";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});